import { useMemo } from 'react';

import { mapTypes } from '@ps-int/datasync-client';
import { GeneralThemesSettingsDatasyncSchema, GeneralThemesSettingsDatasyncService } from '@ps-int/general-themes';
import { useSelector } from 'react-redux';

import { getDatasyncClient } from '../../../helpers/datasync';
import { getConfig } from '../../config/selectors';
import { selectUserUid } from '../../user/selectors';

const THEME_DB = 'ps';
const THEME_COLLECTION = 'settings';

export const useGeneralThemesSettingsDatasyncService = () => {
    const {
        serverTime,
        psSettings,
        yaServices: { cloudAPIHost },
    } = useSelector(getConfig);
    const userUid = useSelector(selectUserUid);

    const ds = useMemo(() => {
        const generalThemesWithDefaults = mapTypes(
            [{ id: 'generalThemes', value: JSON.stringify(psSettings?.generalThemes) }],
            GeneralThemesSettingsDatasyncSchema
        );

        const client = getDatasyncClient({ db: THEME_DB, collection: THEME_COLLECTION, userUid });

        return new GeneralThemesSettingsDatasyncService(client, generalThemesWithDefaults, {
            getNow: () => new Date(serverTime),
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userUid, cloudAPIHost, serverTime]);

    return ds;
};
